import BlogPage from "./BlogPage";
import { Link } from "react-router-dom";

const BlogCard = ({ title, date, content, id, imagepath, url }) => {
  return (
    <div className="text-black border-2 border-slate-200 p-3 flex items-center rounded-md md:border-none md:p-0 dark:border-gray-600">
      <img src={imagepath} className="h-10 mr-5"/>
      <div className="dark:text-white">
        <p className="text-gray-400">{date}</p>
        <Link to={`/${url}`} state={{ title:title, date: date, content:content, imagepath:imagepath }}
          className="text-lg cursor-pointer"
        >
          {title}
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
